module.exports = __webpack_public_path__ + "img/beer_id-13.e98f0a64.png";